import { render } from "./StatDefaultCard.vue?vue&type=template&id=55091517"
import script from "./StatDefaultCard.vue?vue&type=script&lang=js"
export * from "./StatDefaultCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__